import { LiveAnnouncer } from '@angular/cdk/a11y'
import { AfterViewInit, Component, ElementRef, HostListener, ViewChild } from '@angular/core'
import { MatSort, Sort, MatSortModule, MatSortable } from '@angular/material/sort'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'

import { Router } from '@angular/router'
import { MatchesService } from '../../../matches/services/match-add.service'
import { Match } from '../../../../core/models/match.model'
import { MatCardModule } from '@angular/material/card'
import { QualyTeam, Season } from '../../../../core/models/season.model'
import { CommonModule } from '@angular/common'

@Component({
    selector: 'qualy-table',
    templateUrl: 'qualy-table.component.html',
    standalone: true,
    imports: [
        MatTableModule,
        MatSortModule,
        CommonModule,
        MatCardModule
    ],
    styleUrl: 'qualy-table.component.css'
})
export class QualyTableComponent implements AfterViewInit {
  constructor(
    public service: MatchesService,
    private _liveAnnouncer: LiveAnnouncer,
    private router: Router,
    private el: ElementRef
  ) {}

  displayedColumns: string[] = ["index", "team", "points", "matches", "goals", "goals_against", "goals_difference"]
  dataSource = new MatTableDataSource<QualyTeam>()
  seasonData: Season = new Season()
  isCompact: boolean = false

  @ViewChild(MatSort) sort: MatSort = new MatSort

  ngAfterViewInit() {
    this.reloadSeason('2024/2025', 'FIFA Club World Cup')
    this.checkWidth()
  }

  reloadSeason(season: string, competition: string){
    this.service.fetchSeason(season, competition)
    .subscribe(response => {
      this.seasonData = response as Season
      this.dataSource = new MatTableDataSource(this.seasonData.qualy)
      this.dataSource.sortingDataAccessor = (item, property) => {
        if (property === 'points') {
          // Combina puntos y diferencia de goles como un número decimal
          return item.points + (item.goals - item.goals_against) / 100
        }
        if (property === 'goals_difference') {
          // Combina puntos y diferencia de goles como un número decimal
          return item.goals - item.goals_against
        }
        return (item as any)[property]
      }
      this.sort.sort(({id:'points', start:'desc'}) as MatSortable)
      this.dataSource.sort = this.sort
    }) 
  }

  announceSortChange(sortState: Sort) {
    if (sortState.direction) this._liveAnnouncer.announce(`Sorted ${sortState.direction}ending`)
    else this._liveAnnouncer.announce('Sorting cleared')
  }

  openMatchDetail(element:Match){
    return
    this.router.navigate(['/db/matches/detail', element._id])
  }

  @HostListener('window:resize')
  onResize() {
    this.checkWidth()
  }

  checkWidth() {
    const width = this.el.nativeElement.offsetWidth
    this.isCompact = width < 650
  }
}
